<template>
  <div class="modal fade" id="companiesModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="companiesModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 d-flex justify-content-center p-0">
          <p class="companies-modal-header h3 modal-title text-primary fw-bold ubuntu-italic" id="companiesModalLabel">{{ company.sublogoContent.title }}</p>
        </div>
        <div class="modal-body p-0">
          <p class="text-center">
            {{ company.sublogoContent.description }}
          </p>
          <div class="companies-container d-grid">
            <Link :href="logo.webSiteLink" v-for="logo in company.sublogoContent.logos" :key="logo.id">
              <img :src="logo.imgLink" :alt="logo.altText" class="mw-100 fit-cover" width="76" height="38">
            </Link>
          </div>
        </div>
        <div class="modal-footer border-0 justify-content-center p-0">
          <ButtonRed :text="company.sublogoContent.buttonTitle" data-bs-dismiss="modal"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonRed from "@/components/common/ButtonRed";
import Link from "@/components/common/Link";
export default {
  components: {Link, ButtonRed},
  props: {
    company: {
      title: String,
          logo: {
        imgLink: String,
            altText: String
      },
      sublogoImg: {
        imgLink: String,
            altText: String
      },
      sublogoContent: {
        title: String,
            description: String,
            logos: Array
      }
    }
  }
}
</script>
